import { render, staticRenderFns } from "./DangerousGoodExportDialog.vue?vue&type=template&id=5c1b6c16&scoped=true"
import script from "./DangerousGoodExportDialog.vue?vue&type=script&lang=js"
export * from "./DangerousGoodExportDialog.vue?vue&type=script&lang=js"
import style0 from "./DangerousGoodExportDialog.vue?vue&type=style&index=0&id=5c1b6c16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c1b6c16",
  null
  
)

export default component.exports